<template>
  <ODialog ref="dialog" :maxWidth="600">
    <v-card v-if="hasLoaded">
      <ODialogBar title="Variáveis do Gráfico" @close="$refs.dialog.$dismiss" />

      <v-card-text class="pa-3">
        <ORow top fill-x>
          <OMultiSelectList
            :value="selectedVars"
            :rows="firstHalf"
            keyProp="code"
            hideRight
          >
            <template v-slot="{ row }">{{ row.label }}</template>
          </OMultiSelectList>

          <OMultiSelectList
            :value="selectedVars"
            :rows="secondHalf"
            keyProp="code"
            hideRight
          >
            <template v-slot="{ row }">{{ row.label }}</template>
          </OMultiSelectList>
        </ORow>
      </v-card-text>

      <ODialogButtons
        @cancel="$refs.dialog.$dismiss"
        txtApply="OK"
        @apply="$refs.dialog.$apply(selectedVars)"
      />
    </v-card>
  </ODialog>
</template>

<script>
import TripVars from 'trip-vars'
import OMultiSelectList from 'oderon-vue/cpts/OMultiSelectList.vue'

export default {
  components: {
    OMultiSelectList
  },
  data() {
    let availableVars = TripVars.getAll({ showInViewer: true })
    availableVars = [...availableVars] // clone

    // Insere uma nova var "an4speed" para significar "an4, mas
    // com a mesma escala que a velocidade". Aqui, criamos apenas
    // o item que vai ser selecionado; a configuração da scale
    // acontece no VisContainer e depois no chart.js.
    let idx = availableVars.findIndex(x => x.code == 'an4') + 1
    availableVars.splice(idx, 0, {
      code: 'an4speed',
      label: 'Analógico 4 com escala Speed'
    })

    return {
      hasLoaded: false,
      selectedVars: [],
      availableVars
    }
  },
  computed: {
    idx() {
      return Math.ceil(this.availableVars.length / 2)
    },
    firstHalf() {
      return this.availableVars.slice(0, this.idx)
    },
    secondHalf() {
      return this.availableVars.slice(this.idx)
    }
  },
  methods: {
    open(currentVars) {
      this.selectedVars = [...currentVars] // clone
      this.hasLoaded = true
      return this.$refs.dialog.$open()
    }
  }
}
</script>

<style></style>
